import React from 'react';
import { HashLoader } from 'react-spinners';


const overlayStyles = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: '#000000c4',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '5px',
    zIndex: 9999,
};

const LoaderOverlay = ({ loading }) => {
    if (!loading) return null;
    return (
        <div style={overlayStyles}>
            <HashLoader color="#45bcc7" size={50} />
        </div>
    )
}

export default LoaderOverlay;